export const workQueueActionTypes = {
  getAllOrders: '[WorkQueue] get all orders async',
  getAllOrdersWithFilters: '[WorkQueue] get all orders with filters async',
  exportAllOrdersDataPDF: '[All Orders Tab] export All Orders to PDF',
  exportAllOrdersDataCSV: '[All Orders Tab] export All Orders to CSV',
  cancelStepStatusChangeAllOrders: '[WorkQueue] cancel order',
  hideCancelConfirmation: '[WorkQueue] hide cancel confirmation',
  setAllOrdersFiltersByCompany: '[WorkQueue] set all orders filters by company',
  setAllOrdersSortDetails: '[WorkQueue] set all orders sort data',
  setAllOrdersHasMore: '[WorkQueue] set hasmore to false',
  setAllOrdersStatus: '[WorkQueue] set status to null',
};
